(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["leydi-collection-focus"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('leydi-focus-slider')) {
  customElements.define('leydi-focus-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.leydi-focus__track');
      this.buttons = [...this.querySelectorAll('button[data-direction]')];
      this.controls = this.querySelector('.leydi-focus__controls');
      this.update = () => {
        const count = this.track.children.length;
        const page = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
        this.style.setProperty('--focus-progress', (page + 1) / Math.max(1, count));
        this.buttons.forEach(button => button.disabled = Number(button.dataset.direction) < 0 ? page === 0 : page >= count - 1);
      };
      this.click = event => {
        const button = event.target.closest('button[data-direction]');
        if (!button) return;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({left: Number(button.dataset.direction) * this.track.clientWidth, behavior: reduced ? 'instant' : 'smooth'});
      };
      this.addEventListener('click', this.click);
      this.track.addEventListener('scroll', this.update, {passive:true});
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      if (this.controls) this.controls.hidden = false;
      this.update();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.click);
      this.track?.removeEventListener('scroll', this.update);
      this.resize?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
